module.exports = __webpack_public_path__ + "static/img/avatar.b76ab7f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/avatar.jpg
// module id = odpv
// module chunks = 0